/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedTicketsRouteImport } from './routes/_authenticated/tickets'
import { Route as setupSelectOrganizationPlanRouteImport } from './routes/(setup)/select-organization-plan'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as EmbedAssistantAssistantIdRouteImport } from './routes/embed/assistant/$assistantId'
import { Route as AuthenticatedAiHubAssistantAssistantIdRouteImport } from './routes/_authenticated/ai-hub/assistant/$assistantId'
import { Route as AuthenticatedAiHubAssistantDashboardAssistantIdRouteImport } from './routes/_authenticated/ai-hub/assistant-dashboard/$assistantId'
import { Route as AuthenticatedAiHubAssistantAssistantIdIndexRouteImport } from './routes/_authenticated/ai-hub/assistant/$assistantId/index'
import { Route as AuthenticatedAiHubAssistantAssistantIdConversationsRouteImport } from './routes/_authenticated/ai-hub/assistant/$assistantId/conversations'
import { Route as AuthenticatedAiHubAssistantAssistantIdAnalyticsRouteImport } from './routes/_authenticated/ai-hub/assistant/$assistantId/analytics'

const TermsAndConditionsLazyRouteImport = createFileRoute(
  '/terms-and-conditions',
)()
const PrivacyLazyRouteImport = createFileRoute('/privacy')()
const PricingLazyRouteImport = createFileRoute('/pricing')()
const HomeLazyRouteImport = createFileRoute('/home')()
const BlogIndexLazyRouteImport = createFileRoute('/blog/')()
const BlogPostLazyRouteImport = createFileRoute('/blog/post')()
const setupSettingEnvironmentLazyRouteImport = createFileRoute(
  '/(setup)/setting-environment',
)()
const setupCreateOrganizationsLazyRouteImport = createFileRoute(
  '/(setup)/create-organizations',
)()
const setPasswordSetPasswordLazyRouteImport = createFileRoute(
  '/(set-password)/set-password',
)()
const errors503LazyRouteImport = createFileRoute('/(errors)/503')()
const errors500LazyRouteImport = createFileRoute('/(errors)/500')()
const errors404LazyRouteImport = createFileRoute('/(errors)/404')()
const errors403LazyRouteImport = createFileRoute('/(errors)/403')()
const errors401LazyRouteImport = createFileRoute('/(errors)/401')()
const authSignUpLazyRouteImport = createFileRoute('/(auth)/sign-up')()
const authSignInLazyRouteImport = createFileRoute('/(auth)/sign-in')()
const authForgotPasswordLazyRouteImport = createFileRoute(
  '/(auth)/forgot-password',
)()
const acceptOrganizationInviteAcceptOrganizationInviteLazyRouteImport =
  createFileRoute('/(accept-organization-invite)/accept-organization-invite')()
const AuthenticatedSettingsRouteLazyRouteImport = createFileRoute(
  '/_authenticated/settings',
)()
const AuthenticatedUsersIndexLazyRouteImport = createFileRoute(
  '/_authenticated/users/',
)()
const AuthenticatedTranslationTranslationIndexLazyRouteImport = createFileRoute(
  '/_authenticated/translation-translation/',
)()
const AuthenticatedTranslationGlossaryIndexLazyRouteImport = createFileRoute(
  '/_authenticated/translation-glossary/',
)()
const AuthenticatedTranslationFileManageIndexLazyRouteImport = createFileRoute(
  '/_authenticated/translation-file-manage/',
)()
const AuthenticatedTasksIndexLazyRouteImport = createFileRoute(
  '/_authenticated/tasks/',
)()
const AuthenticatedSettingsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/settings/',
)()
const AuthenticatedIntegrationsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/integrations/',
)()
const AuthenticatedHelpCenterIndexLazyRouteImport = createFileRoute(
  '/_authenticated/help-center/',
)()
const AuthenticatedFileSearchIndexLazyRouteImport = createFileRoute(
  '/_authenticated/file-search/',
)()
const AuthenticatedFileManagerIndexLazyRouteImport = createFileRoute(
  '/_authenticated/file-manager/',
)()
const AuthenticatedDashboardIndexLazyRouteImport = createFileRoute(
  '/_authenticated/dashboard/',
)()
const AuthenticatedChatsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/chats/',
)()
const AuthenticatedAiHubIndexLazyRouteImport = createFileRoute(
  '/_authenticated/ai-hub/',
)()
const authNoLayoutWorkflowIndexLazyRouteImport = createFileRoute(
  '/(auth-no-layout)/workflow/',
)()
const AuthenticatedSettingsUsageLazyRouteImport = createFileRoute(
  '/_authenticated/settings/usage',
)()
const AuthenticatedSettingsTokensLazyRouteImport = createFileRoute(
  '/_authenticated/settings/tokens',
)()
const AuthenticatedSettingsPreferencesLazyRouteImport = createFileRoute(
  '/_authenticated/settings/preferences',
)()
const AuthenticatedSettingsNotificationsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/notifications',
)()
const AuthenticatedSettingsMembersLazyRouteImport = createFileRoute(
  '/_authenticated/settings/members',
)()
const AuthenticatedSettingsGroupsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/groups',
)()
const AuthenticatedSettingsDisplayLazyRouteImport = createFileRoute(
  '/_authenticated/settings/display',
)()
const AuthenticatedSettingsBillingLazyRouteImport = createFileRoute(
  '/_authenticated/settings/billing',
)()
const AuthenticatedSettingsAccountLazyRouteImport = createFileRoute(
  '/_authenticated/settings/account',
)()

const TermsAndConditionsLazyRoute = TermsAndConditionsLazyRouteImport.update({
  id: '/terms-and-conditions',
  path: '/terms-and-conditions',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/terms-and-conditions.lazy').then((d) => d.Route),
)
const PrivacyLazyRoute = PrivacyLazyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/privacy.lazy').then((d) => d.Route))
const PricingLazyRoute = PricingLazyRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/pricing.lazy').then((d) => d.Route))
const HomeLazyRoute = HomeLazyRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/home.lazy').then((d) => d.Route))
const CommunityRoute = CommunityRouteImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexLazyRoute = BlogIndexLazyRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/blog/index.lazy').then((d) => d.Route))
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const BlogPostLazyRoute = BlogPostLazyRouteImport.update({
  id: '/blog/post',
  path: '/blog/post',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/blog/post.lazy').then((d) => d.Route))
const setupSettingEnvironmentLazyRoute = setupSettingEnvironmentLazyRouteImport
  .update({
    id: '/(setup)/setting-environment',
    path: '/setting-environment',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() =>
    import('./routes/(setup)/setting-environment.lazy').then((d) => d.Route),
  )
const setupCreateOrganizationsLazyRoute =
  setupCreateOrganizationsLazyRouteImport
    .update({
      id: '/(setup)/create-organizations',
      path: '/create-organizations',
      getParentRoute: () => rootRouteImport,
    } as any)
    .lazy(() =>
      import('./routes/(setup)/create-organizations.lazy').then((d) => d.Route),
    )
const setPasswordSetPasswordLazyRoute = setPasswordSetPasswordLazyRouteImport
  .update({
    id: '/(set-password)/set-password',
    path: '/set-password',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() =>
    import('./routes/(set-password)/set-password.lazy').then((d) => d.Route),
  )
const errors503LazyRoute = errors503LazyRouteImport
  .update({
    id: '/(errors)/503',
    path: '/503',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/503.lazy').then((d) => d.Route))
const errors500LazyRoute = errors500LazyRouteImport
  .update({
    id: '/(errors)/500',
    path: '/500',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/500.lazy').then((d) => d.Route))
const errors404LazyRoute = errors404LazyRouteImport
  .update({
    id: '/(errors)/404',
    path: '/404',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/404.lazy').then((d) => d.Route))
const errors403LazyRoute = errors403LazyRouteImport
  .update({
    id: '/(errors)/403',
    path: '/403',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/403.lazy').then((d) => d.Route))
const errors401LazyRoute = errors401LazyRouteImport
  .update({
    id: '/(errors)/401',
    path: '/401',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/401.lazy').then((d) => d.Route))
const authSignUpLazyRoute = authSignUpLazyRouteImport
  .update({
    id: '/(auth)/sign-up',
    path: '/sign-up',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(auth)/sign-up.lazy').then((d) => d.Route))
const authSignInLazyRoute = authSignInLazyRouteImport
  .update({
    id: '/(auth)/sign-in',
    path: '/sign-in',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(auth)/sign-in.lazy').then((d) => d.Route))
const authForgotPasswordLazyRoute = authForgotPasswordLazyRouteImport
  .update({
    id: '/(auth)/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/forgot-password.lazy').then((d) => d.Route),
  )
const acceptOrganizationInviteAcceptOrganizationInviteLazyRoute =
  acceptOrganizationInviteAcceptOrganizationInviteLazyRouteImport
    .update({
      id: '/(accept-organization-invite)/accept-organization-invite',
      path: '/accept-organization-invite',
      getParentRoute: () => rootRouteImport,
    } as any)
    .lazy(() =>
      import(
        './routes/(accept-organization-invite)/accept-organization-invite.lazy'
      ).then((d) => d.Route),
    )
const AuthenticatedSettingsRouteLazyRoute =
  AuthenticatedSettingsRouteLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/route.lazy').then((d) => d.Route),
  )
const AuthenticatedTicketsRoute = AuthenticatedTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const setupSelectOrganizationPlanRoute =
  setupSelectOrganizationPlanRouteImport.update({
    id: '/(setup)/select-organization-plan',
    path: '/select-organization-plan',
    getParentRoute: () => rootRouteImport,
  } as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersIndexLazyRoute =
  AuthenticatedUsersIndexLazyRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/users/index.lazy').then((d) => d.Route),
  )
const AuthenticatedTranslationTranslationIndexLazyRoute =
  AuthenticatedTranslationTranslationIndexLazyRouteImport.update({
    id: '/translation-translation/',
    path: '/translation-translation/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/translation-translation/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedTranslationGlossaryIndexLazyRoute =
  AuthenticatedTranslationGlossaryIndexLazyRouteImport.update({
    id: '/translation-glossary/',
    path: '/translation-glossary/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/translation-glossary/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedTranslationFileManageIndexLazyRoute =
  AuthenticatedTranslationFileManageIndexLazyRouteImport.update({
    id: '/translation-file-manage/',
    path: '/translation-file-manage/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/translation-file-manage/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedTasksIndexLazyRoute =
  AuthenticatedTasksIndexLazyRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/tasks/index.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsIndexLazyRoute =
  AuthenticatedSettingsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/index.lazy').then((d) => d.Route),
  )
const AuthenticatedIntegrationsIndexLazyRoute =
  AuthenticatedIntegrationsIndexLazyRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/integrations/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedHelpCenterIndexLazyRoute =
  AuthenticatedHelpCenterIndexLazyRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/help-center/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedFileSearchIndexLazyRoute =
  AuthenticatedFileSearchIndexLazyRouteImport.update({
    id: '/file-search/',
    path: '/file-search/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/file-search/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedFileManagerIndexLazyRoute =
  AuthenticatedFileManagerIndexLazyRouteImport.update({
    id: '/file-manager/',
    path: '/file-manager/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/file-manager/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedDashboardIndexLazyRoute =
  AuthenticatedDashboardIndexLazyRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/dashboard/index.lazy').then((d) => d.Route),
  )
const AuthenticatedChatsIndexLazyRoute =
  AuthenticatedChatsIndexLazyRouteImport.update({
    id: '/chats/',
    path: '/chats/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/chats/index.lazy').then((d) => d.Route),
  )
const AuthenticatedAiHubIndexLazyRoute =
  AuthenticatedAiHubIndexLazyRouteImport.update({
    id: '/ai-hub/',
    path: '/ai-hub/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/ai-hub/index.lazy').then((d) => d.Route),
  )
const authNoLayoutWorkflowIndexLazyRoute =
  authNoLayoutWorkflowIndexLazyRouteImport
    .update({
      id: '/(auth-no-layout)/workflow/',
      path: '/workflow/',
      getParentRoute: () => rootRouteImport,
    } as any)
    .lazy(() =>
      import('./routes/(auth-no-layout)/workflow/index.lazy').then(
        (d) => d.Route,
      ),
    )
const AuthenticatedSettingsUsageLazyRoute =
  AuthenticatedSettingsUsageLazyRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/usage.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsTokensLazyRoute =
  AuthenticatedSettingsTokensLazyRouteImport.update({
    id: '/tokens',
    path: '/tokens',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/tokens.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsPreferencesLazyRoute =
  AuthenticatedSettingsPreferencesLazyRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/preferences.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsNotificationsLazyRoute =
  AuthenticatedSettingsNotificationsLazyRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/notifications.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsMembersLazyRoute =
  AuthenticatedSettingsMembersLazyRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/members.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsGroupsLazyRoute =
  AuthenticatedSettingsGroupsLazyRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/groups.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsDisplayLazyRoute =
  AuthenticatedSettingsDisplayLazyRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/display.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsBillingLazyRoute =
  AuthenticatedSettingsBillingLazyRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/billing.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAccountLazyRoute =
  AuthenticatedSettingsAccountLazyRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/account.lazy').then(
      (d) => d.Route,
    ),
  )
const EmbedAssistantAssistantIdRoute =
  EmbedAssistantAssistantIdRouteImport.update({
    id: '/embed/assistant/$assistantId',
    path: '/embed/assistant/$assistantId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedAiHubAssistantAssistantIdRoute =
  AuthenticatedAiHubAssistantAssistantIdRouteImport.update({
    id: '/ai-hub/assistant/$assistantId',
    path: '/ai-hub/assistant/$assistantId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/ai-hub/assistant/$assistantId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAiHubAssistantDashboardAssistantIdRoute =
  AuthenticatedAiHubAssistantDashboardAssistantIdRouteImport.update({
    id: '/ai-hub/assistant-dashboard/$assistantId',
    path: '/ai-hub/assistant-dashboard/$assistantId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/ai-hub/assistant-dashboard/$assistantId.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedAiHubAssistantAssistantIdIndexRoute =
  AuthenticatedAiHubAssistantAssistantIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAiHubAssistantAssistantIdRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/ai-hub/assistant/$assistantId/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedAiHubAssistantAssistantIdConversationsRoute =
  AuthenticatedAiHubAssistantAssistantIdConversationsRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => AuthenticatedAiHubAssistantAssistantIdRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/ai-hub/assistant/$assistantId/conversations.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedAiHubAssistantAssistantIdAnalyticsRoute =
  AuthenticatedAiHubAssistantAssistantIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedAiHubAssistantAssistantIdRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/ai-hub/assistant/$assistantId/analytics.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/community': typeof CommunityRoute
  '/home': typeof HomeLazyRoute
  '/pricing': typeof PricingLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/terms-and-conditions': typeof TermsAndConditionsLazyRoute
  '/otp': typeof authOtpRoute
  '/sign-in-2': typeof authSignIn2Route
  '/select-organization-plan': typeof setupSelectOrganizationPlanRoute
  '/tickets': typeof AuthenticatedTicketsRoute
  '/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/accept-organization-invite': typeof acceptOrganizationInviteAcceptOrganizationInviteLazyRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/sign-in': typeof authSignInLazyRoute
  '/sign-up': typeof authSignUpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/set-password': typeof setPasswordSetPasswordLazyRoute
  '/create-organizations': typeof setupCreateOrganizationsLazyRoute
  '/setting-environment': typeof setupSettingEnvironmentLazyRoute
  '/blog/post': typeof BlogPostLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/blog': typeof BlogIndexLazyRoute
  '/embed/assistant/$assistantId': typeof EmbedAssistantAssistantIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/settings/groups': typeof AuthenticatedSettingsGroupsLazyRoute
  '/settings/members': typeof AuthenticatedSettingsMembersLazyRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/settings/preferences': typeof AuthenticatedSettingsPreferencesLazyRoute
  '/settings/tokens': typeof AuthenticatedSettingsTokensLazyRoute
  '/settings/usage': typeof AuthenticatedSettingsUsageLazyRoute
  '/workflow': typeof authNoLayoutWorkflowIndexLazyRoute
  '/ai-hub': typeof AuthenticatedAiHubIndexLazyRoute
  '/chats': typeof AuthenticatedChatsIndexLazyRoute
  '/dashboard': typeof AuthenticatedDashboardIndexLazyRoute
  '/file-manager': typeof AuthenticatedFileManagerIndexLazyRoute
  '/file-search': typeof AuthenticatedFileSearchIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/integrations': typeof AuthenticatedIntegrationsIndexLazyRoute
  '/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/tasks': typeof AuthenticatedTasksIndexLazyRoute
  '/translation-file-manage': typeof AuthenticatedTranslationFileManageIndexLazyRoute
  '/translation-glossary': typeof AuthenticatedTranslationGlossaryIndexLazyRoute
  '/translation-translation': typeof AuthenticatedTranslationTranslationIndexLazyRoute
  '/users': typeof AuthenticatedUsersIndexLazyRoute
  '/ai-hub/assistant-dashboard/$assistantId': typeof AuthenticatedAiHubAssistantDashboardAssistantIdRoute
  '/ai-hub/assistant/$assistantId': typeof AuthenticatedAiHubAssistantAssistantIdRouteWithChildren
  '/ai-hub/assistant/$assistantId/analytics': typeof AuthenticatedAiHubAssistantAssistantIdAnalyticsRoute
  '/ai-hub/assistant/$assistantId/conversations': typeof AuthenticatedAiHubAssistantAssistantIdConversationsRoute
  '/ai-hub/assistant/$assistantId/': typeof AuthenticatedAiHubAssistantAssistantIdIndexRoute
}
export interface FileRoutesByTo {
  '/community': typeof CommunityRoute
  '/home': typeof HomeLazyRoute
  '/pricing': typeof PricingLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/terms-and-conditions': typeof TermsAndConditionsLazyRoute
  '/otp': typeof authOtpRoute
  '/sign-in-2': typeof authSignIn2Route
  '/select-organization-plan': typeof setupSelectOrganizationPlanRoute
  '/tickets': typeof AuthenticatedTicketsRoute
  '/accept-organization-invite': typeof acceptOrganizationInviteAcceptOrganizationInviteLazyRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/sign-in': typeof authSignInLazyRoute
  '/sign-up': typeof authSignUpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/set-password': typeof setPasswordSetPasswordLazyRoute
  '/create-organizations': typeof setupCreateOrganizationsLazyRoute
  '/setting-environment': typeof setupSettingEnvironmentLazyRoute
  '/blog/post': typeof BlogPostLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/blog': typeof BlogIndexLazyRoute
  '/embed/assistant/$assistantId': typeof EmbedAssistantAssistantIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/settings/groups': typeof AuthenticatedSettingsGroupsLazyRoute
  '/settings/members': typeof AuthenticatedSettingsMembersLazyRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/settings/preferences': typeof AuthenticatedSettingsPreferencesLazyRoute
  '/settings/tokens': typeof AuthenticatedSettingsTokensLazyRoute
  '/settings/usage': typeof AuthenticatedSettingsUsageLazyRoute
  '/workflow': typeof authNoLayoutWorkflowIndexLazyRoute
  '/ai-hub': typeof AuthenticatedAiHubIndexLazyRoute
  '/chats': typeof AuthenticatedChatsIndexLazyRoute
  '/dashboard': typeof AuthenticatedDashboardIndexLazyRoute
  '/file-manager': typeof AuthenticatedFileManagerIndexLazyRoute
  '/file-search': typeof AuthenticatedFileSearchIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/integrations': typeof AuthenticatedIntegrationsIndexLazyRoute
  '/settings': typeof AuthenticatedSettingsIndexLazyRoute
  '/tasks': typeof AuthenticatedTasksIndexLazyRoute
  '/translation-file-manage': typeof AuthenticatedTranslationFileManageIndexLazyRoute
  '/translation-glossary': typeof AuthenticatedTranslationGlossaryIndexLazyRoute
  '/translation-translation': typeof AuthenticatedTranslationTranslationIndexLazyRoute
  '/users': typeof AuthenticatedUsersIndexLazyRoute
  '/ai-hub/assistant-dashboard/$assistantId': typeof AuthenticatedAiHubAssistantDashboardAssistantIdRoute
  '/ai-hub/assistant/$assistantId/analytics': typeof AuthenticatedAiHubAssistantAssistantIdAnalyticsRoute
  '/ai-hub/assistant/$assistantId/conversations': typeof AuthenticatedAiHubAssistantAssistantIdConversationsRoute
  '/ai-hub/assistant/$assistantId': typeof AuthenticatedAiHubAssistantAssistantIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/community': typeof CommunityRoute
  '/home': typeof HomeLazyRoute
  '/pricing': typeof PricingLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/terms-and-conditions': typeof TermsAndConditionsLazyRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(setup)/select-organization-plan': typeof setupSelectOrganizationPlanRoute
  '/_authenticated/tickets': typeof AuthenticatedTicketsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/(accept-organization-invite)/accept-organization-invite': typeof acceptOrganizationInviteAcceptOrganizationInviteLazyRoute
  '/(auth)/forgot-password': typeof authForgotPasswordLazyRoute
  '/(auth)/sign-in': typeof authSignInLazyRoute
  '/(auth)/sign-up': typeof authSignUpLazyRoute
  '/(errors)/401': typeof errors401LazyRoute
  '/(errors)/403': typeof errors403LazyRoute
  '/(errors)/404': typeof errors404LazyRoute
  '/(errors)/500': typeof errors500LazyRoute
  '/(errors)/503': typeof errors503LazyRoute
  '/(set-password)/set-password': typeof setPasswordSetPasswordLazyRoute
  '/(setup)/create-organizations': typeof setupCreateOrganizationsLazyRoute
  '/(setup)/setting-environment': typeof setupSettingEnvironmentLazyRoute
  '/blog/post': typeof BlogPostLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/blog/': typeof BlogIndexLazyRoute
  '/embed/assistant/$assistantId': typeof EmbedAssistantAssistantIdRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/_authenticated/settings/groups': typeof AuthenticatedSettingsGroupsLazyRoute
  '/_authenticated/settings/members': typeof AuthenticatedSettingsMembersLazyRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/_authenticated/settings/preferences': typeof AuthenticatedSettingsPreferencesLazyRoute
  '/_authenticated/settings/tokens': typeof AuthenticatedSettingsTokensLazyRoute
  '/_authenticated/settings/usage': typeof AuthenticatedSettingsUsageLazyRoute
  '/(auth-no-layout)/workflow/': typeof authNoLayoutWorkflowIndexLazyRoute
  '/_authenticated/ai-hub/': typeof AuthenticatedAiHubIndexLazyRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexLazyRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexLazyRoute
  '/_authenticated/file-manager/': typeof AuthenticatedFileManagerIndexLazyRoute
  '/_authenticated/file-search/': typeof AuthenticatedFileSearchIndexLazyRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/_authenticated/integrations/': typeof AuthenticatedIntegrationsIndexLazyRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexLazyRoute
  '/_authenticated/translation-file-manage/': typeof AuthenticatedTranslationFileManageIndexLazyRoute
  '/_authenticated/translation-glossary/': typeof AuthenticatedTranslationGlossaryIndexLazyRoute
  '/_authenticated/translation-translation/': typeof AuthenticatedTranslationTranslationIndexLazyRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexLazyRoute
  '/_authenticated/ai-hub/assistant-dashboard/$assistantId': typeof AuthenticatedAiHubAssistantDashboardAssistantIdRoute
  '/_authenticated/ai-hub/assistant/$assistantId': typeof AuthenticatedAiHubAssistantAssistantIdRouteWithChildren
  '/_authenticated/ai-hub/assistant/$assistantId/analytics': typeof AuthenticatedAiHubAssistantAssistantIdAnalyticsRoute
  '/_authenticated/ai-hub/assistant/$assistantId/conversations': typeof AuthenticatedAiHubAssistantAssistantIdConversationsRoute
  '/_authenticated/ai-hub/assistant/$assistantId/': typeof AuthenticatedAiHubAssistantAssistantIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/community'
    | '/home'
    | '/pricing'
    | '/privacy'
    | '/terms-and-conditions'
    | '/otp'
    | '/sign-in-2'
    | '/select-organization-plan'
    | '/tickets'
    | '/settings'
    | '/accept-organization-invite'
    | '/forgot-password'
    | '/sign-in'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/set-password'
    | '/create-organizations'
    | '/setting-environment'
    | '/blog/post'
    | '/'
    | '/blog'
    | '/embed/assistant/$assistantId'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/display'
    | '/settings/groups'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/preferences'
    | '/settings/tokens'
    | '/settings/usage'
    | '/workflow'
    | '/ai-hub'
    | '/chats'
    | '/dashboard'
    | '/file-manager'
    | '/file-search'
    | '/help-center'
    | '/integrations'
    | '/settings/'
    | '/tasks'
    | '/translation-file-manage'
    | '/translation-glossary'
    | '/translation-translation'
    | '/users'
    | '/ai-hub/assistant-dashboard/$assistantId'
    | '/ai-hub/assistant/$assistantId'
    | '/ai-hub/assistant/$assistantId/analytics'
    | '/ai-hub/assistant/$assistantId/conversations'
    | '/ai-hub/assistant/$assistantId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/community'
    | '/home'
    | '/pricing'
    | '/privacy'
    | '/terms-and-conditions'
    | '/otp'
    | '/sign-in-2'
    | '/select-organization-plan'
    | '/tickets'
    | '/accept-organization-invite'
    | '/forgot-password'
    | '/sign-in'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/set-password'
    | '/create-organizations'
    | '/setting-environment'
    | '/blog/post'
    | '/'
    | '/blog'
    | '/embed/assistant/$assistantId'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/display'
    | '/settings/groups'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/preferences'
    | '/settings/tokens'
    | '/settings/usage'
    | '/workflow'
    | '/ai-hub'
    | '/chats'
    | '/dashboard'
    | '/file-manager'
    | '/file-search'
    | '/help-center'
    | '/integrations'
    | '/settings'
    | '/tasks'
    | '/translation-file-manage'
    | '/translation-glossary'
    | '/translation-translation'
    | '/users'
    | '/ai-hub/assistant-dashboard/$assistantId'
    | '/ai-hub/assistant/$assistantId/analytics'
    | '/ai-hub/assistant/$assistantId/conversations'
    | '/ai-hub/assistant/$assistantId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/community'
    | '/home'
    | '/pricing'
    | '/privacy'
    | '/terms-and-conditions'
    | '/(auth)/otp'
    | '/(auth)/sign-in-2'
    | '/(setup)/select-organization-plan'
    | '/_authenticated/tickets'
    | '/_authenticated/settings'
    | '/(accept-organization-invite)/accept-organization-invite'
    | '/(auth)/forgot-password'
    | '/(auth)/sign-in'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/(set-password)/set-password'
    | '/(setup)/create-organizations'
    | '/(setup)/setting-environment'
    | '/blog/post'
    | '/_authenticated/'
    | '/blog/'
    | '/embed/assistant/$assistantId'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/groups'
    | '/_authenticated/settings/members'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/preferences'
    | '/_authenticated/settings/tokens'
    | '/_authenticated/settings/usage'
    | '/(auth-no-layout)/workflow/'
    | '/_authenticated/ai-hub/'
    | '/_authenticated/chats/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/file-manager/'
    | '/_authenticated/file-search/'
    | '/_authenticated/help-center/'
    | '/_authenticated/integrations/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/translation-file-manage/'
    | '/_authenticated/translation-glossary/'
    | '/_authenticated/translation-translation/'
    | '/_authenticated/users/'
    | '/_authenticated/ai-hub/assistant-dashboard/$assistantId'
    | '/_authenticated/ai-hub/assistant/$assistantId'
    | '/_authenticated/ai-hub/assistant/$assistantId/analytics'
    | '/_authenticated/ai-hub/assistant/$assistantId/conversations'
    | '/_authenticated/ai-hub/assistant/$assistantId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  CommunityRoute: typeof CommunityRoute
  HomeLazyRoute: typeof HomeLazyRoute
  PricingLazyRoute: typeof PricingLazyRoute
  PrivacyLazyRoute: typeof PrivacyLazyRoute
  TermsAndConditionsLazyRoute: typeof TermsAndConditionsLazyRoute
  authOtpRoute: typeof authOtpRoute
  authSignIn2Route: typeof authSignIn2Route
  setupSelectOrganizationPlanRoute: typeof setupSelectOrganizationPlanRoute
  acceptOrganizationInviteAcceptOrganizationInviteLazyRoute: typeof acceptOrganizationInviteAcceptOrganizationInviteLazyRoute
  authForgotPasswordLazyRoute: typeof authForgotPasswordLazyRoute
  authSignInLazyRoute: typeof authSignInLazyRoute
  authSignUpLazyRoute: typeof authSignUpLazyRoute
  errors401LazyRoute: typeof errors401LazyRoute
  errors403LazyRoute: typeof errors403LazyRoute
  errors404LazyRoute: typeof errors404LazyRoute
  errors500LazyRoute: typeof errors500LazyRoute
  errors503LazyRoute: typeof errors503LazyRoute
  setPasswordSetPasswordLazyRoute: typeof setPasswordSetPasswordLazyRoute
  setupCreateOrganizationsLazyRoute: typeof setupCreateOrganizationsLazyRoute
  setupSettingEnvironmentLazyRoute: typeof setupSettingEnvironmentLazyRoute
  BlogPostLazyRoute: typeof BlogPostLazyRoute
  BlogIndexLazyRoute: typeof BlogIndexLazyRoute
  EmbedAssistantAssistantIdRoute: typeof EmbedAssistantAssistantIdRoute
  authNoLayoutWorkflowIndexLazyRoute: typeof authNoLayoutWorkflowIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-and-conditions': {
      id: '/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof TermsAndConditionsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community': {
      id: '/community'
      path: '/community'
      fullPath: '/community'
      preLoaderRoute: typeof CommunityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/blog/post': {
      id: '/blog/post'
      path: '/blog/post'
      fullPath: '/blog/post'
      preLoaderRoute: typeof BlogPostLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(setup)/setting-environment': {
      id: '/(setup)/setting-environment'
      path: '/setting-environment'
      fullPath: '/setting-environment'
      preLoaderRoute: typeof setupSettingEnvironmentLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(setup)/create-organizations': {
      id: '/(setup)/create-organizations'
      path: '/create-organizations'
      fullPath: '/create-organizations'
      preLoaderRoute: typeof setupCreateOrganizationsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(set-password)/set-password': {
      id: '/(set-password)/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof setPasswordSetPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(accept-organization-invite)/accept-organization-invite': {
      id: '/(accept-organization-invite)/accept-organization-invite'
      path: '/accept-organization-invite'
      fullPath: '/accept-organization-invite'
      preLoaderRoute: typeof acceptOrganizationInviteAcceptOrganizationInviteLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tickets': {
      id: '/_authenticated/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AuthenticatedTicketsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(setup)/select-organization-plan': {
      id: '/(setup)/select-organization-plan'
      path: '/select-organization-plan'
      fullPath: '/select-organization-plan'
      preLoaderRoute: typeof setupSelectOrganizationPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/translation-translation/': {
      id: '/_authenticated/translation-translation/'
      path: '/translation-translation'
      fullPath: '/translation-translation'
      preLoaderRoute: typeof AuthenticatedTranslationTranslationIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/translation-glossary/': {
      id: '/_authenticated/translation-glossary/'
      path: '/translation-glossary'
      fullPath: '/translation-glossary'
      preLoaderRoute: typeof AuthenticatedTranslationGlossaryIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/translation-file-manage/': {
      id: '/_authenticated/translation-file-manage/'
      path: '/translation-file-manage'
      fullPath: '/translation-file-manage'
      preLoaderRoute: typeof AuthenticatedTranslationFileManageIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/integrations/': {
      id: '/_authenticated/integrations/'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthenticatedIntegrationsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/file-search/': {
      id: '/_authenticated/file-search/'
      path: '/file-search'
      fullPath: '/file-search'
      preLoaderRoute: typeof AuthenticatedFileSearchIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/file-manager/': {
      id: '/_authenticated/file-manager/'
      path: '/file-manager'
      fullPath: '/file-manager'
      preLoaderRoute: typeof AuthenticatedFileManagerIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedChatsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ai-hub/': {
      id: '/_authenticated/ai-hub/'
      path: '/ai-hub'
      fullPath: '/ai-hub'
      preLoaderRoute: typeof AuthenticatedAiHubIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(auth-no-layout)/workflow/': {
      id: '/(auth-no-layout)/workflow/'
      path: '/workflow'
      fullPath: '/workflow'
      preLoaderRoute: typeof authNoLayoutWorkflowIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings/usage': {
      id: '/_authenticated/settings/usage'
      path: '/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof AuthenticatedSettingsUsageLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/tokens': {
      id: '/_authenticated/settings/tokens'
      path: '/tokens'
      fullPath: '/settings/tokens'
      preLoaderRoute: typeof AuthenticatedSettingsTokensLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/preferences': {
      id: '/_authenticated/settings/preferences'
      path: '/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof AuthenticatedSettingsPreferencesLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/members': {
      id: '/_authenticated/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthenticatedSettingsMembersLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/groups': {
      id: '/_authenticated/settings/groups'
      path: '/groups'
      fullPath: '/settings/groups'
      preLoaderRoute: typeof AuthenticatedSettingsGroupsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/embed/assistant/$assistantId': {
      id: '/embed/assistant/$assistantId'
      path: '/embed/assistant/$assistantId'
      fullPath: '/embed/assistant/$assistantId'
      preLoaderRoute: typeof EmbedAssistantAssistantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/ai-hub/assistant/$assistantId': {
      id: '/_authenticated/ai-hub/assistant/$assistantId'
      path: '/ai-hub/assistant/$assistantId'
      fullPath: '/ai-hub/assistant/$assistantId'
      preLoaderRoute: typeof AuthenticatedAiHubAssistantAssistantIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ai-hub/assistant-dashboard/$assistantId': {
      id: '/_authenticated/ai-hub/assistant-dashboard/$assistantId'
      path: '/ai-hub/assistant-dashboard/$assistantId'
      fullPath: '/ai-hub/assistant-dashboard/$assistantId'
      preLoaderRoute: typeof AuthenticatedAiHubAssistantDashboardAssistantIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ai-hub/assistant/$assistantId/': {
      id: '/_authenticated/ai-hub/assistant/$assistantId/'
      path: '/'
      fullPath: '/ai-hub/assistant/$assistantId/'
      preLoaderRoute: typeof AuthenticatedAiHubAssistantAssistantIdIndexRouteImport
      parentRoute: typeof AuthenticatedAiHubAssistantAssistantIdRoute
    }
    '/_authenticated/ai-hub/assistant/$assistantId/conversations': {
      id: '/_authenticated/ai-hub/assistant/$assistantId/conversations'
      path: '/conversations'
      fullPath: '/ai-hub/assistant/$assistantId/conversations'
      preLoaderRoute: typeof AuthenticatedAiHubAssistantAssistantIdConversationsRouteImport
      parentRoute: typeof AuthenticatedAiHubAssistantAssistantIdRoute
    }
    '/_authenticated/ai-hub/assistant/$assistantId/analytics': {
      id: '/_authenticated/ai-hub/assistant/$assistantId/analytics'
      path: '/analytics'
      fullPath: '/ai-hub/assistant/$assistantId/analytics'
      preLoaderRoute: typeof AuthenticatedAiHubAssistantAssistantIdAnalyticsRouteImport
      parentRoute: typeof AuthenticatedAiHubAssistantAssistantIdRoute
    }
  }
}

interface AuthenticatedSettingsRouteLazyRouteChildren {
  AuthenticatedSettingsAccountLazyRoute: typeof AuthenticatedSettingsAccountLazyRoute
  AuthenticatedSettingsBillingLazyRoute: typeof AuthenticatedSettingsBillingLazyRoute
  AuthenticatedSettingsDisplayLazyRoute: typeof AuthenticatedSettingsDisplayLazyRoute
  AuthenticatedSettingsGroupsLazyRoute: typeof AuthenticatedSettingsGroupsLazyRoute
  AuthenticatedSettingsMembersLazyRoute: typeof AuthenticatedSettingsMembersLazyRoute
  AuthenticatedSettingsNotificationsLazyRoute: typeof AuthenticatedSettingsNotificationsLazyRoute
  AuthenticatedSettingsPreferencesLazyRoute: typeof AuthenticatedSettingsPreferencesLazyRoute
  AuthenticatedSettingsTokensLazyRoute: typeof AuthenticatedSettingsTokensLazyRoute
  AuthenticatedSettingsUsageLazyRoute: typeof AuthenticatedSettingsUsageLazyRoute
  AuthenticatedSettingsIndexLazyRoute: typeof AuthenticatedSettingsIndexLazyRoute
}

const AuthenticatedSettingsRouteLazyRouteChildren: AuthenticatedSettingsRouteLazyRouteChildren =
  {
    AuthenticatedSettingsAccountLazyRoute:
      AuthenticatedSettingsAccountLazyRoute,
    AuthenticatedSettingsBillingLazyRoute:
      AuthenticatedSettingsBillingLazyRoute,
    AuthenticatedSettingsDisplayLazyRoute:
      AuthenticatedSettingsDisplayLazyRoute,
    AuthenticatedSettingsGroupsLazyRoute: AuthenticatedSettingsGroupsLazyRoute,
    AuthenticatedSettingsMembersLazyRoute:
      AuthenticatedSettingsMembersLazyRoute,
    AuthenticatedSettingsNotificationsLazyRoute:
      AuthenticatedSettingsNotificationsLazyRoute,
    AuthenticatedSettingsPreferencesLazyRoute:
      AuthenticatedSettingsPreferencesLazyRoute,
    AuthenticatedSettingsTokensLazyRoute: AuthenticatedSettingsTokensLazyRoute,
    AuthenticatedSettingsUsageLazyRoute: AuthenticatedSettingsUsageLazyRoute,
    AuthenticatedSettingsIndexLazyRoute: AuthenticatedSettingsIndexLazyRoute,
  }

const AuthenticatedSettingsRouteLazyRouteWithChildren =
  AuthenticatedSettingsRouteLazyRoute._addFileChildren(
    AuthenticatedSettingsRouteLazyRouteChildren,
  )

interface AuthenticatedAiHubAssistantAssistantIdRouteChildren {
  AuthenticatedAiHubAssistantAssistantIdAnalyticsRoute: typeof AuthenticatedAiHubAssistantAssistantIdAnalyticsRoute
  AuthenticatedAiHubAssistantAssistantIdConversationsRoute: typeof AuthenticatedAiHubAssistantAssistantIdConversationsRoute
  AuthenticatedAiHubAssistantAssistantIdIndexRoute: typeof AuthenticatedAiHubAssistantAssistantIdIndexRoute
}

const AuthenticatedAiHubAssistantAssistantIdRouteChildren: AuthenticatedAiHubAssistantAssistantIdRouteChildren =
  {
    AuthenticatedAiHubAssistantAssistantIdAnalyticsRoute:
      AuthenticatedAiHubAssistantAssistantIdAnalyticsRoute,
    AuthenticatedAiHubAssistantAssistantIdConversationsRoute:
      AuthenticatedAiHubAssistantAssistantIdConversationsRoute,
    AuthenticatedAiHubAssistantAssistantIdIndexRoute:
      AuthenticatedAiHubAssistantAssistantIdIndexRoute,
  }

const AuthenticatedAiHubAssistantAssistantIdRouteWithChildren =
  AuthenticatedAiHubAssistantAssistantIdRoute._addFileChildren(
    AuthenticatedAiHubAssistantAssistantIdRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedTicketsRoute: typeof AuthenticatedTicketsRoute
  AuthenticatedSettingsRouteLazyRoute: typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAiHubIndexLazyRoute: typeof AuthenticatedAiHubIndexLazyRoute
  AuthenticatedChatsIndexLazyRoute: typeof AuthenticatedChatsIndexLazyRoute
  AuthenticatedDashboardIndexLazyRoute: typeof AuthenticatedDashboardIndexLazyRoute
  AuthenticatedFileManagerIndexLazyRoute: typeof AuthenticatedFileManagerIndexLazyRoute
  AuthenticatedFileSearchIndexLazyRoute: typeof AuthenticatedFileSearchIndexLazyRoute
  AuthenticatedHelpCenterIndexLazyRoute: typeof AuthenticatedHelpCenterIndexLazyRoute
  AuthenticatedIntegrationsIndexLazyRoute: typeof AuthenticatedIntegrationsIndexLazyRoute
  AuthenticatedTasksIndexLazyRoute: typeof AuthenticatedTasksIndexLazyRoute
  AuthenticatedTranslationFileManageIndexLazyRoute: typeof AuthenticatedTranslationFileManageIndexLazyRoute
  AuthenticatedTranslationGlossaryIndexLazyRoute: typeof AuthenticatedTranslationGlossaryIndexLazyRoute
  AuthenticatedTranslationTranslationIndexLazyRoute: typeof AuthenticatedTranslationTranslationIndexLazyRoute
  AuthenticatedUsersIndexLazyRoute: typeof AuthenticatedUsersIndexLazyRoute
  AuthenticatedAiHubAssistantDashboardAssistantIdRoute: typeof AuthenticatedAiHubAssistantDashboardAssistantIdRoute
  AuthenticatedAiHubAssistantAssistantIdRoute: typeof AuthenticatedAiHubAssistantAssistantIdRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedTicketsRoute: AuthenticatedTicketsRoute,
  AuthenticatedSettingsRouteLazyRoute:
    AuthenticatedSettingsRouteLazyRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAiHubIndexLazyRoute: AuthenticatedAiHubIndexLazyRoute,
  AuthenticatedChatsIndexLazyRoute: AuthenticatedChatsIndexLazyRoute,
  AuthenticatedDashboardIndexLazyRoute: AuthenticatedDashboardIndexLazyRoute,
  AuthenticatedFileManagerIndexLazyRoute:
    AuthenticatedFileManagerIndexLazyRoute,
  AuthenticatedFileSearchIndexLazyRoute: AuthenticatedFileSearchIndexLazyRoute,
  AuthenticatedHelpCenterIndexLazyRoute: AuthenticatedHelpCenterIndexLazyRoute,
  AuthenticatedIntegrationsIndexLazyRoute:
    AuthenticatedIntegrationsIndexLazyRoute,
  AuthenticatedTasksIndexLazyRoute: AuthenticatedTasksIndexLazyRoute,
  AuthenticatedTranslationFileManageIndexLazyRoute:
    AuthenticatedTranslationFileManageIndexLazyRoute,
  AuthenticatedTranslationGlossaryIndexLazyRoute:
    AuthenticatedTranslationGlossaryIndexLazyRoute,
  AuthenticatedTranslationTranslationIndexLazyRoute:
    AuthenticatedTranslationTranslationIndexLazyRoute,
  AuthenticatedUsersIndexLazyRoute: AuthenticatedUsersIndexLazyRoute,
  AuthenticatedAiHubAssistantDashboardAssistantIdRoute:
    AuthenticatedAiHubAssistantDashboardAssistantIdRoute,
  AuthenticatedAiHubAssistantAssistantIdRoute:
    AuthenticatedAiHubAssistantAssistantIdRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  CommunityRoute: CommunityRoute,
  HomeLazyRoute: HomeLazyRoute,
  PricingLazyRoute: PricingLazyRoute,
  PrivacyLazyRoute: PrivacyLazyRoute,
  TermsAndConditionsLazyRoute: TermsAndConditionsLazyRoute,
  authOtpRoute: authOtpRoute,
  authSignIn2Route: authSignIn2Route,
  setupSelectOrganizationPlanRoute: setupSelectOrganizationPlanRoute,
  acceptOrganizationInviteAcceptOrganizationInviteLazyRoute:
    acceptOrganizationInviteAcceptOrganizationInviteLazyRoute,
  authForgotPasswordLazyRoute: authForgotPasswordLazyRoute,
  authSignInLazyRoute: authSignInLazyRoute,
  authSignUpLazyRoute: authSignUpLazyRoute,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
  setPasswordSetPasswordLazyRoute: setPasswordSetPasswordLazyRoute,
  setupCreateOrganizationsLazyRoute: setupCreateOrganizationsLazyRoute,
  setupSettingEnvironmentLazyRoute: setupSettingEnvironmentLazyRoute,
  BlogPostLazyRoute: BlogPostLazyRoute,
  BlogIndexLazyRoute: BlogIndexLazyRoute,
  EmbedAssistantAssistantIdRoute: EmbedAssistantAssistantIdRoute,
  authNoLayoutWorkflowIndexLazyRoute: authNoLayoutWorkflowIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
